import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DATABASE_EDIT_COLUMN_NAME } from '../../../../types/AnalyticsTypes';
import InputTransient from '../Utils/InputTransient';
import ColumnHeaderMore from './ColumnHeaderMore';

function ColumnHeader(_ref) {
  var database = _ref.database,
      column = _ref.column,
      isFocused = _ref.isFocused,
      isActive = _ref.isActive,
      isSelected = _ref.isSelected,
      readOnly = _ref.readOnly,
      sort = _ref.sort,
      columnCount = _ref.columnCount;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isRenaming = _React$useState2[0],
      setIsRenaming = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isHovered = _React$useState4[0],
      setIsHovered = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      isControlOpen = _React$useState6[0],
      _setIsControlOpen = _React$useState6[1];

  var headerRef = React.useRef();
  React.useEffect(function () {
    database.scrollIfNeeded(column.key, headerRef.current);
  }, [column.key, database]);
  React.useEffect(function () {
    if (isFocused && !isRenaming) {
      setIsRenaming(true);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [isFocused]);

  function onRename() {
    setIsRenaming(true);
    database.blur();
  }

  function onClickTitle() {
    if (database.readOnly) return;
    database.selectColumn(column.key);
  }

  function onDoubleClickTitle(event) {
    if (database.readOnly) return;
    event.stopPropagation();
    event.preventDefault();
    onRename();
  }

  var onChangeTitle = React.useCallback(function (name) {
    database.setColumn(column.key, {
      name: name
    }).command('track', DATABASE_EDIT_COLUMN_NAME);
    setIsRenaming(true);
  }, [database, column.key, setIsRenaming]);
  return React.createElement("td", {
    ref: headerRef,
    "data-qa": "database-columns-cell",
    className: classNames('slite-editor-database-cell', 'shade-20 background-shade-50 font-weight-medium', 'data-hj-whitelist', //Hotjar whitelist
    {
      'is-focused': isFocused,
      'background-primary-shade-dark': isSelected,
      'is-active': isActive
    }),
    style: {
      width: "".concat(100 / columnCount, "%"),
      minWidth: database.run('getWidth', column.type)
    },
    onMouseMove: function onMouseMove() {
      return !isHovered && setIsHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    }
  }, React.createElement("div", {
    className: "flexbox flexbox-align-center"
  }, React.createElement("div", {
    className: "flexbox flexbox-grow flexbox-align-center padding-vertical-small padding-horizontal-normal",
    onClick: onClickTitle,
    onDoubleClick: onDoubleClickTitle
  }, React.createElement("div", {
    className: "margin-right-normal shade-20",
    style: {
      marginTop: -2
    }
  }, database.run('renderColumnIcon', column.type)), React.createElement(InputTransient, {
    autoSelect: isRenaming,
    readOnly: !isRenaming,
    className: "slite-editor-database-input flexbox flexbox-grow shade-10 font-weight-medium",
    placeholder: "Untitled",
    value: column.name,
    onChange: onChangeTitle,
    onBlur: function onBlur() {
      return setIsRenaming(false);
    }
  })), !readOnly && React.createElement(ColumnHeaderMore, {
    setIsControlOpen: function setIsControlOpen(open) {
      if (!open) setIsHovered(false);

      _setIsControlOpen(open);
    },
    isHovered: isHovered,
    isControlOpen: isControlOpen,
    database: database,
    column: column,
    sort: sort
  })));
}

ColumnHeader.propTypes = {
  database: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  sort: PropTypes.object,
  isOrderFrozen: PropTypes.bool,
  columnCount: PropTypes.number
};
export default React.memo(ColumnHeader);